import Tone from 'tone';
import Resolution from 'engine/Resolution.js';

const BASE_RESOLUTION = new Resolution(32, false);

const triggerTimesCache = {};

// Util for determining trigger times based on
// resolution and the current step

function getTriggerTimes(stepNumber, resolution, isSequence=false) {
    let step = triggerTimesCache[stepNumber];
    if (step !== undefined) {
        let triggerTimes = step[resolution.toString()];
        if (triggerTimes !== undefined) {
            return triggerTimes;
        }
    } else {
        triggerTimesCache[stepNumber] = {};
    }
    
    let triggerTimes = getTriggerTimesHelper(stepNumber, resolution, isSequence);
    triggerTimesCache[stepNumber][resolution.toString()] = triggerTimes;
    return triggerTimes;
}

function getTriggerTimesHelper(stepNumber, resolution, isSequence=false) {
    let minStepNumber = resolution.transformStepAtResolution2(stepNumber, BASE_RESOLUTION);
    let maxStepNumber = resolution.transformStepAtResolution2(stepNumber + 1, BASE_RESOLUTION);
    
    let stepsAtResolution = new Set(); 
    if (Math.floor(minStepNumber) == minStepNumber) {
        stepsAtResolution.add(minStepNumber);
    } else if (maxStepNumber - minStepNumber > 1) {
        stepsAtResolution.add(Math.ceil(minStepNumber));
    }
    
    // is there a whole number between the two numbers, not including the second number?
    if (isSequence) {
        if (Math.floor(maxStepNumber) >= Math.floor(minStepNumber) &&
            Math.floor(maxStepNumber) != maxStepNumber) {
            
            stepsAtResolution.add(Math.floor(maxStepNumber));
        }
    } else {
        if (Math.floor(maxStepNumber) > Math.floor(minStepNumber) &&
            Math.floor(maxStepNumber) != maxStepNumber) {
            
            stepsAtResolution.add(Math.floor(maxStepNumber));
        }
    }
    
    stepsAtResolution = Array.from(stepsAtResolution);
    let ret = [];
    // now we want to convert them back to the base resolution
    for (let i=0 ; i < stepsAtResolution.length; i++) {
        let step = stepsAtResolution[i];
        let baseResolutionStep = BASE_RESOLUTION.transformStepAtResolution2(step, resolution);
        let offset = baseResolutionStep - stepNumber;
        ret.push({step: step, time: new Tone.Time('32n') * offset});
        
    }
    return ret;
}

export {getTriggerTimes}
